module.exports = __webpack_public_path__ + "static/media/DsDatasets.1d11feff.svg";